import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'vbr_launch_deadline';
const DURATION_MS = 15 * 60 * 1000; // 15 minutes
const getDeadline = (): number => {
  if (typeof window === 'undefined') return Date.now() + DURATION_MS;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  const now = Date.now();
  if (stored) {
    const d = parseInt(stored, 10);
    if (!Number.isNaN(d) && d > now) return d;
  }
  const deadline = now + DURATION_MS;
  window.localStorage.setItem(STORAGE_KEY, String(deadline));
  return deadline;
};
const TimeBlock: React.FC<{
  value: number;
  label: string;
}> = ({
  value,
  label
}) => <div className="flex flex-col items-center" data-id="element-43">
    <div className="bg-navy-900 border border-vbred/40 rounded-lg w-14 h-14 md:w-16 md:h-16 flex items-center justify-center shadow-[0_0_15px_rgba(230,57,70,0.15)]" data-id="element-44">
      <span className="font-display text-2xl md:text-3xl font-bold text-vbgold tabular-nums" data-id="element-45">
        {String(value).padStart(2, '0')}
      </span>
    </div>
    <span className="text-[9px] md:text-[10px] font-bold uppercase tracking-widest text-gray-400 mt-1.5" data-id="element-46">
      {label}
    </span>
  </div>;
export const CountdownTimer = () => {
  const [deadline, setDeadline] = useState<number>(() => getDeadline());
  const [remaining, setRemaining] = useState<number>(() => Math.max(0, deadline - Date.now()));
  useEffect(() => {
    const tick = () => {
      let diff = deadline - Date.now();
      if (diff <= 0) {
        // Restart the window to keep the offer alive and maintain urgency
        const next = Date.now() + DURATION_MS;
        window.localStorage.setItem(STORAGE_KEY, String(next));
        setDeadline(next);
        diff = DURATION_MS;
      }
      setRemaining(diff);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [deadline]);
  const totalSeconds = Math.floor(remaining / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return <div className="flex items-center justify-center gap-2 md:gap-3" role="timer" aria-live="off" aria-label="Time remaining for the launch price" data-id="element-47">
      <TimeBlock value={hours} label="Hrs" data-id="element-48" />
      <span className="font-display text-2xl md:text-3xl text-vbred font-bold pb-5 animate-pulse" data-id="element-49">
        :
      </span>
      <TimeBlock value={minutes} label="Min" data-id="element-50" />
      <span className="font-display text-2xl md:text-3xl text-vbred font-bold pb-5 animate-pulse" data-id="element-51">
        :
      </span>
      <TimeBlock value={seconds} label="Sec" data-id="element-52" />
    </div>;
};